module.exports = __webpack_public_path__ + "img/userManWithSpace.770cd3fb.svg";